import { useFlag } from 'utils/launchdarkly';
import { OTPAuthDeliveryMethod, isOTPEmailEnabled, isOTPEnabled, isOTPSMSEnabled } from 'utils/otp';

/**
 * Centralizes the calculation of which "One Time Password" method we are using
 */
export const useOtpFeature = () => {
  const enableOtpFlagValue = useFlag('enable-one-time-password') as OTPAuthDeliveryMethod;
  const smsOtpEnabled = isOTPSMSEnabled(enableOtpFlagValue);
  const emailOtpEnabled = isOTPEmailEnabled(enableOtpFlagValue);

  return {
    enableOtpFlagValue: enableOtpFlagValue ?? OTPAuthDeliveryMethod.None,
    jwtEmailEnabled: !isOTPEnabled(enableOtpFlagValue),
    smsOtpEnabled,
    emailOtpEnabled,
  };
};
